"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterContacts = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const components_common_link_1 = require("@hotelplan/components.common.link");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const libs_tracking_1 = require("@hotelplan/libs.tracking");
const FooterHeading_1 = require("./FooterHeading");
const linkCss = {
    display: 'flex',
    marginBottom: 3,
    minHeight: ['60px', '55px'],
    fontSize: ['18px', 3],
    lineHeight: ['1.1', '1.5'],
    '.icon': {
        margin: 'auto',
        width: ['28px', '25px'],
        height: ['28px', '25px'],
    },
};
const linkIconCss = {
    backgroundColor: 'primary',
    width: ['60px', '55px'],
    display: 'flex',
    color: 'white',
};
const linkTextCss = {
    border: '1px solid',
    borderColor: 'borderColor',
    flex: 1,
    borderLeft: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: ['column', 'row'],
    justifyContent: ['center', 'flex-start'],
    alignItems: ['start', 'center'],
    px: [3, 4],
};
const FooterContactsWrapper = styled_components_1.default.div(({ theme: { space, colors, media, shadows } }) => ({
    borderRadius: '0 0 4px 4px',
    padding: space[4],
    paddingBottom: space[4],
    paddingTop: 0,
    backgroundColor: colors.background,
    boxShadow: 'none',
    [media.tablet]: {
        borderRadius: 0,
        padding: '70px',
        paddingBottom: '40px',
        paddingTop: '40px',
        flexBasis: '50%',
        boxShadow: shadows.blockShadow,
    },
}));
const FooterContactsTitle = (0, styled_components_1.default)(FooterHeading_1.FooterHeading)((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: ['none', 'block'],
    mb: [null, '36px'],
}));
const PhoneLink = (0, styled_components_1.default)(components_common_link_1.Link)((0, util_theme_sxc_1.sx2CssThemeFn)(linkCss));
const PhoneIcon = styled_components_1.default.span.attrs({
    children: react_1.default.createElement(components_common_icon_1.Icon, { name: "phone" }),
})((0, util_theme_sxc_1.sx2CssThemeFn)(linkIconCss));
const PhoneContent = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)(linkTextCss, {
    '.-title': {
        display: ['none', 'block'],
        color: ['secondary', 'inherit'],
        fontSize: [1, 3],
        lineHeight: '1.3',
        paddingRight: [null, 1],
    },
    '.-number': {},
}));
const EmailLink = (0, styled_components_1.default)(components_common_link_1.Link)((0, util_theme_sxc_1.sx2CssThemeFn)(linkCss, {
    mb: [3, '36px'],
}));
const EmailContent = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)(linkTextCss));
const EmailIcon = styled_components_1.default.span.attrs({
    children: react_1.default.createElement(components_common_icon_1.Icon, { name: "mail" }),
})((0, util_theme_sxc_1.sx2CssThemeFn)(linkIconCss));
const WorkingTime = styled_components_1.default.p((0, util_theme_sxc_1.sx2CssThemeFn)({
    textAlign: ['center', 'start'],
    fontSize: [1, 3],
}));
const phoneClickHandler = () => (0, libs_tracking_1.trackClicks)({
    type: libs_tracking_1.ClickEventType.CALL,
    payload: { source: 'footer' },
});
const FooterContacts = ({ emailAddress, emailTitle, mainTitle, openingHours, phoneNumber, phoneTitle, }) => {
    return (react_1.default.createElement(FooterContactsWrapper, { "data-id": "footer-contact" },
        react_1.default.createElement(FooterContactsTitle, { "data-id": "title" },
            mainTitle,
            "\u00A0"),
        react_1.default.createElement(PhoneLink, { href: `tel:${phoneNumber}`, "data-id": "phone-link", onClick: phoneClickHandler },
            react_1.default.createElement(PhoneIcon, null),
            react_1.default.createElement(PhoneContent, { "data-id": "phone-content" },
                react_1.default.createElement("p", { className: "-title", "data-id": "phone-title" }, phoneTitle && phoneTitle + ':'),
                react_1.default.createElement("span", { className: "-number", "data-id": "phone-number" }, phoneNumber))),
        react_1.default.createElement(EmailLink, { href: emailAddress, "data-id": "email-link" },
            react_1.default.createElement(EmailIcon, null),
            react_1.default.createElement(EmailContent, null,
                react_1.default.createElement("span", { "data-id": "email-title" }, emailTitle))),
        react_1.default.createElement(WorkingTime, { "data-id": "opening-hours" }, openingHours)));
};
exports.FooterContacts = FooterContacts;
//# sourceMappingURL=FooterContacts.js.map